function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
//Limitless imports
import { DialogueBody } from "../../../../../customer/components";
import CustomerDialogueWrapper from "../customer-dialogue-wrapper/CustomerDialogueWrapper";
const CustomerDialogue = ({
  classes,
  dialogue,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(CustomerDialogueWrapper, _extends({
    dialogue: dialogue
  }, rest), /*#__PURE__*/React.createElement(DialogueBody, {
    body: dialogue.body,
    textStyling: classes.bodyText,
    lineClamp: rest.lineClamp,
    index: dialogue.dialogueId
  }));
};
const styles = ({
  palette
}) => ({
  bodyText: {
    color: palette.primary.dark
  }
});
export default withStyles(styles)(CustomerDialogue);
CustomerDialogue.propTypes = {
  dialogue: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired
};